/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { useEffect, useState } from 'react';

import { useLazyGetTableStatusQuery } from '../../PageSubscriberMobile/store';

export const useTableListStatusCheck = () => {
    const [isComplete, setComplete] = useState(false);
    const [pollingInterval, setPollingInterval] = useState(1000);

    const [getListStatus, { data }] = useLazyGetTableStatusQuery({
        pollingInterval,
    });

    useEffect(() => {
        getListStatus();
    }, [getListStatus]);

    useEffect(() => {
        if (data?.isComplete) {
            setPollingInterval(0);
            setComplete(true);
        }
    }, [data]);

    return { isComplete };
};
